module.exports = __webpack_public_path__ + "static/media/bl2.41c5d320.webp";